export default import.meta.ROLLUP_FILE_URL_Ab2zkHLYZvR8pLFRo8OHig